import useLayoutProps from 'common/hooks/useLayoutProps';
import useLocale from 'common/hooks/useLocale';
import { isNonEmpty, multiLang } from 'common/utils/utils';
import NotificationListViewOverLay from 'components/notification/NotificationListViewOverlay';
import moment from 'moment';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { IRootState } from 'reducers';
import { notificationActions } from 'reducers/notification';
import { NotificationListItemProps } from '../../components/notification/NotificationListItem';
import useNotificationActionByModule from './useNotificationActionByModule';

const GlobalNotificationListOverLay = () => {
  const { notifications, hasMore, criteria, overlayViewOpened } = useSelector((state: IRootState) => state.notification);
  const dispatch = useDispatch();
  const history = useHistory();
  const DISPLAY_DATETIME_FORMAT = useSelector((state: IRootState) => state.systemSettings.System?.SYSTEM_PARAM?.DISPLAY_DATETIME_FORMAT);
  const layoutProps = useLayoutProps();
  const { langNotification, locale } = useLocale();

  useEffect(() => {
    if (overlayViewOpened) dispatch(notificationActions.fetch({ isSwitchingPage: false }));
  }, [ overlayViewOpened, dispatch ]);
  
  const notificationActionByModule = useNotificationActionByModule();

  return <NotificationListViewOverLay 
    layoutProps={layoutProps}
    onBackClick={() => dispatch(notificationActions.closeOverlayView())}
    notifications={notifications.map((n) => ({ 
			...n, 
			title: multiLang(locale, n.titleTc, n.titleEn, n.titleSc) ?? '',
			content: multiLang(locale, n.contentTc, n.contentEn, n.contentSc) ?? '',
			date: n.date ? moment(n.date).format(DISPLAY_DATETIME_FORMAT) : '',
      onNavigate: isNonEmpty(n.link) && isNonEmpty(notificationActionByModule(n)?.['navigateUrl']) ? () => { 
        if (!n.isRead) dispatch(notificationActions.read({ id: n.id }));
        history.push(`/${notificationActionByModule(n)?.['navigateUrl']}/${n.link}`);
        dispatch(notificationActions.closeOverlayView());
      }: notificationActionByModule(n)?.['onNavigate'],
      onPrimaryAction: notificationActionByModule(n)?.['primaryAction'],
      onSecondaryAction: notificationActionByModule(n)?.['secondaryAction'],
      finished: notificationActionByModule(n)?.['finished'],
		} as NotificationListItemProps))}
    hasMore={hasMore}

    onRequestNextPage={() => dispatch(notificationActions.fetch({ isSwitchingPage: true }))}
    onRefresh={() => dispatch(notificationActions.fetch({ isSwitchingPage: false }))}
    overlayViewOpened={overlayViewOpened}
  />
}

export default GlobalNotificationListOverLay;
